<template>

    <sidebar :user="user" :disableUserMenu="isInspecting" :showOptions="false" :isLoading="loading" class="sidebar--student">

        <accordion :collections="groupTerms" :initialExpanded="expandedGroupTerm" @expanded="expandedGroupTerm = $event.id" :isLoading="isLoadingGroupTerm" class="accordion--workspace">
            <template scope="groupTerm">

                <timeline :items="progressions" @click="viewAssignment" :isActive="isAssignmentActive" v-if="groupTerm.id != -1">

                    <template slot="item" scope="progress">
                        <assignment :progress="progress" :isActive="isAssignmentActive(progress)"></assignment>
                    </template>

                    <template slot="empty">
                        <span v-if="groupTerm.isFirst">Dit is jouw persoonlijke werkmap, hier komen al jouw gemaakte opdrachten in te staan. </span>Kies een opdracht om aan je werkmap toe te voegen.
                    </template>

                </timeline>


            </template>
        </accordion>

    </sidebar>

</template>


<script>

import Sidebar from 'js/admin/components/sidebar/Sidebar.vue'
import Accordion from 'js/admin/components/sidebar/Accordion.vue'
import Timeline from 'js/admin/components/sidebar/Timeline.vue'
import Assignment from 'js/components/sidebar/Assignment.vue'

import notify from 'js/components/notifications/notificationsMixin'
import track from 'js/helpers/analytics'

import { getGroupTermsForGroup, getProgressForUserAndGroupTerm } from 'js/vuex/getters'
import { fetchGroupTerm } from 'js/vuex/actions'

export default {
    mixins: [ notify ],

    components: { Sidebar, Accordion, Timeline, Assignment, },

    props: {
        user: {},
        group: {},
        loading: {
            type: Boolean,
            default: false,
        },
        hideUnfinished: {
            type: Boolean,
            default: false,
        },
        isInspecting: {
            type: Boolean,
            default: false,
        }
    },

    data: function() {
        return {
            isLoadingGroupTerm: false,
            expandedGroupTerm: null,
        }
    },

    vuex: {
        getters: {
            getGroupTermsForGroup,
            getProgressForUserAndGroupTerm
        },
        actions: {
            fetchGroupTerm,
        }
    },

    computed: {

        groupTerms: function() {

            const overview = {
                id: -1,
                title: 'Overzicht',
                isFirst: false,
                isExpandable: false,
                link: { name: 'student.overview' }
            }

            const terms = this.getGroupTermsForGroup(this.group.id).map( (gt, index) => {
                const term = this.$store.state.terms.storage[ gt.term[0] ]
                return {
                    id: gt.id,
                    title: (index+1) + '. ' + term.title,
                    isFirst: index === 0,
                    link: { name: this.isInspecting ? 'students.period' : 'student.period', params: { sidebar: true } }
                }
            })

            return this.isInspecting ? terms : [overview].concat(terms)
        },

        progressions: function() {
            if ( this.expandedGroupTerm == null || this.expandedGroupTerm === -1) {
                return []
            }

            return this.getProgressForUserAndGroupTerm( this.user.id, this.expandedGroupTerm, this.group.id)
                .filter( this.isProgressVisible )
                .sort( (a,b) => {
                    // note that this is sorted in reverse, newest first
                    if (a.started > b.started) {
                        return -1;
                    }
                    if (a.started < b.started) {
                        return 1;
                    }
                    return 0
                })
        },

        currentGroupTermId: function() {
            return this.$route.name === 'student.overview' ? null : this.group.currentGroupTerm[0]
        },

    },

    methods: {

        assignmentForProgress: function(progress) {
            return this.$store.state.assignments.storage[ progress.assignment ]
        },

        viewAssignment: function(progress) {
            this.$router.push({ name: 'assignment', params: { assignmentId: this.assignmentForProgress(progress).id } })
        },

        isAssignmentActive: function(progress) {
            return progress.assignment === this.$route.params.assignmentId
        },


        isProgressVisible: function(progress) {
            return !(progress.finished == null && this.hideUnfinished)
        },

        loadGroupTerm: function(id) {

            this.isLoadingGroupTerm = true

            const includeProgress = this.user == null ? null : this.user.id

            this.fetchGroupTerm(id, includeProgress)
                .catch( err => {
                    track.exception('Can\'t load term', err)
                    this.$error('Kan periode niet laden.')
                })
                .then( () => this.isLoadingGroupTerm = false)

        },

        setExpandedGroupTerm: function() {
            const route = this.$route

            if (route.params.sidebar === true) {
                // internally generated, so expecting an `expanded` event from accordion
                return
            }

            if (route.name === 'student.overview') {
                this.expandedGroupTerm = null
                return
            }

            if ( route.params.periodId != null ){
                const gt = this.group.groupTerms
                    .map( id => this.$store.state.groups.terms[id] )
                    .find( gt => gt.groupPeriods.indexOf(route.params.periodId) !== -1 )

                if (gt != null) {
                    this.expandedGroupTerm = gt.id
                    return
                }
            }

            // note that groupPeriods don't contain groupAssignment info on init
            // so deeplinking to an assignment will expand currentGroupTerm instead
            if (route.params.assignmentId != null ) {
                const gt = this.group.groupTerms
                    .map( id => this.$store.state.groups.terms[id] )
                    .find( gt => gt.groupPeriods.map( id => this.$store.state.groups.periods[id])
                        .find(gp => gp.groupAssignments.indexOf(route.params.assignmentId) !== -1)
                    )

                if (gt != null) {
                    this.expandedGroupTerm = gt.id
                    return
                }
            }

            // fallback current term
            if (this.expandedGroupTerm == null || route.name === 'student.period') {
                this.expandedGroupTerm = this.currentGroupTermId
            }
        }

    },

    watch: {
        expandedGroupTerm: {
            handler: function(id, previous) {
                // teacher loads first data in GroupManager,
                // if switching to different id load here
                if (id != null && (previous != null || !this.isInspecting)) {
                    this.loadGroupTerm(id)
                }
            },
            immediate: true
        },

        group: function() {
            // when user changes group
            this.setExpandedGroupTerm()
        },

        '$route': {
            handler: function() {
                this.setExpandedGroupTerm()
            },
            immediate: true
        },
    }

}
</script>



<style lang="scss">

    @import 'global';

    .accordion.accordion--workspace {
        padding-top: 0;
    }

</style>



// WEBPACK FOOTER //
// SidebarWorkspace.vue?778c6944